export default [
  {
    id: 1,
    date: "2021-06-05",
    topicstart: "1:40 PM",
    topicend: "2:00 PM",
    topic: "Opening Ceremony & Handover of ASEAN Presidentship",
    // title: "Session 1: Neuro-oncology",
    // chairperson1: "Chariperson : Dr Regunath Kandasamy",
    // chairperson2: "Chariperson : Dr Sharon Casilda Theophilus",
    // replay: true,
    url: "",
  },
  {
    id: 2,
    date: "2021-06-05",
    start: "02:00 PM",
    end: "02:15 PM",
    desc: "The Paramedian Supracerebellar-Transtentorial Approach To The Entire Length Of the Mediobasal Temporal Region by Prof Dr Ugur Türe / Turkey",	
    title: "Session 1: Neuro-oncology",	
    chairperson1: "Chariperson : Dr Regunath Kandasamy",
    chairperson2: "Chariperson : Dr Sharon Casilda Theophilus",
    // speaker: "by Prof Dr Ugur Türe / Turkey",
    speakerId: "50",
    // replay: true,
    url: "",
  },
  {
    id: 3,
    date: "2021-06-05",
    start: "02:15 PM",
    end: "02:30 PM",
    desc: "Step Into The Future: Current And Future Intraoperative Technologies In Glioma Surgery by Prof Dr Miguel Arraez / Spain",
    // title: "Session 1: Neuro-oncology",
    // speaker: "by Prof Dr Miguel Arraez / Spain",
    speakerId: "19",
    // replay: true,
    url: "",
  },
  {
    id: 4,
    date: "2021-06-05",
    start: "02:30 PM",
    end: "02:45 PM",
    desc: "Methylation Patterns Guiding Brain Tumor Management by Prof Dr Gelareh Zadeh / Canada",
    // title: "Session 1: Neuro-oncology",
    // speaker: "by Prof Dr Gelareh Zadeh / Canada",
    speakerId: "51",
    // replay: false,
    url: "",
  },
  {
    id: 5,
    date: "2021-06-05",
    start: "02:45 PM",
    end: "03:00 PM",
    desc: "Q&A",
    // title: "Session 1: Neuro-oncology",
    // replay: false,
    url: "",
  },
  {
    id: 6,
    date: "2021-06-05",
    start: "03:00 PM",
    end: "03:10 PM",
    desc: "Break",
    // title: "Session 1: Neuro-oncology",
    // replay: true,
    url: "",
  },
  {
    id: 7,
    date: "2021-06-05",
    start: "03:10 PM",
    end: "03:30 PM",
    desc: "Early Maximal Safe Resection For Low-Grade Gliomas: A Connectomal-Based Surgical Approach, About Over 1100 Awake Procedures by Prof Dr Hugues Duffau / France",
    title: "Plenary 1: Neuro-oncology",
    chairperson1: "Chairperson : Dr Regunath Kandasamy",
    chairperson2: "Chairperson : Dr Sharon Casilda Theophilus",
    // speaker: "by Prof Dr Hugues Duffau / France",
    speakerId: "32",
    // replay: false,
    url: "",
  },
  {
    id: 8,
    date: "2021-06-05",
    start: "03:30 PM",
    end: "03:35 PM",
    desc: "Break",
    // title: "Plenary 1: Neuro-oncology",
    // replay: true,
    url: "",
  },
  {
    id: 9,
    date: "2021-06-05",
    start: "03:35 PM",
    end: "03:50 PM",
    desc: "Degenerative Spine And Biological Treatments by Prof Dr Tito Arcadio Perilla Cepeda / Colombia",
    title: "Session 2: Spine",
    chairperson1: "Chairperson : Professor Dr Abdul Hafid Bajamal",
    chairperson2: "Chairperson : Dato' Dr Kantha Rasalingam",
    // speaker: "by Prof Dr Tito Arcadio Perilla Cepeda / Colombia",
    speakerId: "34",
    // replay: true,
    url: "",
  },
  {
    id: 10,
    date: "2021-06-05",
    start: "03:50 PM",
    end: "04:05 PM",
    desc: "Transoral, Endoscopic C2 Transcorporeal, C2-3 Fragmentecteomy: A Novel Anterior Approach To C2-3 Disc Hernia And Spinal Cord Decompression by Assist Prof Dr Elmer Jose Meceda / Philippines",
    // title: "Session 2: Spine",
    // speaker: "by Assist Prof Dr Elmer Jose Meceda / Philippines",
    speakerId: "35",
    // replay: true,
    url: "",
  },
  {
    id: 11,
    date: "2021-06-05",
    start: "04:05 PM",
    end: "04:20 PM",
    desc: "Thoraco-lumbar Fractures. The Role Of Imaging For Diagnostic And Outcome by Prof Dr Abdul Hafid Bajamal / Indonesia",
    // title: "Session 2: Spine",
    // speaker: "by Prof Dr Abdul Hafid Bajamal / Indonesia",
    speakerId: "44",
    // replay: true,
    url: "",
  },
  {
    id: 12,
    date: "2021-06-05",
    start: "04:20 PM",
    end: "04:35 PM",
    desc: "Future Of Spinal Cord Recovery by Prof Dr Salman Sharif / Pakistan",
    // title: "Session 2: Spine",
    // speaker: "by Prof Dr Salman Sharif / Pakistan",
    speakerId: "20",
    // replay: true,
    url: "",
  },
  {
    id: 13,
    date: "2021-06-05",
    start: "04:35 PM",
    end: "05:05 PM",
    desc: "Q&A",
    // title: "Session 2: Spine",
    // replay: true,
    url: "",
  },
  {
    id: 14,
    date: "2021-06-05",
    start: "05:05 PM",
    end: "05:15 PM",
    desc: "Break",
    // title: "Session 2: Spine",
    // replay: false,
    url: "",
  },
  {
    id: 15,
    date: "2021-06-05",
    start: "05:15 PM",
    end: "05:35 PM",
    desc: "The Future Of Clinical Neuroscience: From Nanoneurosurgery, Neuro-photonics To AI Machine Learning And Microwave Ablation Therapy by Prof Dr Babak Kateb / USA",
    title: "Plenary 2: Technological Advancements in Neurosurgery",
    chairperson1: "Chairperson : Prof Dr Zamzuri Idris",
    chairperson2: "Chairperson : Dr Azman Raffiq",
    // speaker: "by Prof Dr Babak Kateb / USA ",
    speakerId: "31",
    // replay: true,
    url: "",
  },
  {
    id: 16,
    date: "2021-06-05",
    start: "05:35 PM",
    end: "05:45 PM",
    desc: "Break",
    // title: "Plenary 2: Technological Advancements in Neurosurgery",
    // replay: false,
    url: "",
  },
  {
    id: 17,
    date: "2021-06-05",
    start: "05:45 PM",
    end: "06:00 PM",
    desc: "Reducing The Cognitive Footprint Of Brain Surgery With Connectomics by Associate Professor Dr Michael Sughrue / Australia",
    title: "Session 3: Technological Advancements in Neurosurgery",
    chairperson1: "Chairperson : Prof Dr Zamzuri Idris",
    chairperson2: "Chairperson : Dr Azman Raffiq",
    // speaker: "by Professor Dr Michael Sughrue / Australia",
    speakerId: "16",
    // replay: true,
    url: "",
  },
  {
    id: 18,
    date: "2021-06-05",
    start: "06:00 PM",
    end: "06:15 PM",
    desc: "Application Of Robotics And Medical Engineering In Neurosurgery by Prof Dr Akio Morita / Japan",
    // title: "Session 3: Technological Advancements in Neurosurgery",
    // speaker: "by Prof Dr Akio Morita / Japan",
    speakerId: "14",

    // replay: true,
    url: "",
  },
  {
    id: 19,
    ate: "2021-06-05",
    start: "06:15 PM",
    end: "06:30 PM",
    desc: "Q & A",
    // title: "Session 3: Technological Advancements in Neurosurgery",
    // replay: false,
    url: "",
  },
  {
    id: 20,
    date: "2021-06-05",
    start: "06:30 PM",
    end: "06:40 PM",
    desc: "Break",
    // title: "Session 3: Technological Advancements in Neurosurgery",
    // replay: false,
    url: "",
  },
  {
    id: 21,
    date: "2021-06-05",
    start: "06:40 PM",
    end: "06:55 PM",
    desc: "Skull Base Surgery: Sapientia and Veritas by Professor Dr Anil Nanda / USA",
    title: "Session 4: Skull Base",
    chairperson1: "Chairperson : Dr Regunath Kandasamy",
    chairperson2: "Chairperson : Dr Mohd Raffiz Mohd Ali",
    // speaker: "by Professor Dr Anil Nanda / USA",
    speakerId: "17",
    // replay: true,
    url: "",
  },
  {
    id: 22,
    date: "2021-06-05",
    start: "06:55 PM",
    end: "07:10 PM",
    desc: "Trends In The Management Of Skull Base Chordoma by Professor Dr Basant Kumar Misra / India",
    // title: "Session 4: Skull Base",
    // speaker: "by Professor Dr Basant Kumar Misra / India",
    speakerId: "12",
    // replay: true,
    url: "",
  },
  {
    id: 23,
    date: "2021-06-05",
    start: "07:10 PM",
    end: "07:25 PM",
    desc: "Endoscopic Skullbase Surgery- Looking Into The Crystal Ball by Dr Ramesh Nair / United Kingdom",
    // title: "Session 4: Skull Base",
    // speaker: "by Dr Ramesh Nair / United Kingdom ",
    speakerId: "61",
    // replay: true,
    url: "",
  },
  {
    id: 24,
    date: "2021-06-05",
    start: "07:25 PM",
    end: "07:50 PM",
    desc: "Q&A",
    // title: "Session 4: Skull Base",
    // replay: false,
    url: "",
  },
  {
    id: 25,
    date: "2021-06-05",
    start: "07:50 PM",
    end: "08:00 PM",
    desc: "Break",
    // title: "Session 4: Skull Base",
    // replay: false,
    url: "",
  },
  // {
  //   id: 26,
  //   date: "2021-06-05",
  //   start: "07:45 PM",
  //   end: "08:00 PM",
  //   desc: "Glomus Jugulare Tumor: A surgical disease by Prof Dr Luis Borba / Brazil",
  //   title: "Session 4: Skull Base/Vascular",
  //   // speaker: "by Prof Dr Luis Borba / Brazil",
  //   speakerId: "38",
  //   chairperson1: "Chairperson : Dr Regunath Kandasamy",
  //   chairperson2: "Chairperson : Dr Mohd Raffiz Mohd Ali",
  //   // replay: true,
  //   url: "",
  // },
  {
    id: 27,
    date: "2021-06-05",
    start: "08:00 PM",
    end: "08:15 PM",
    desc: "Decision Making In Unruptured Aneurysms by Professor Dr Ioan Stefan Florian / Romania",
    title: "Session 4: Skull Base/Vascular",
    chairperson1: "Chairperson : Dr Regunath Kandasamy",
    chairperson2: "Chairperson : Dr Mohd Raffiz Mohd Ali",
    // title: "Session 4: Skull Base/Vascular",
    // replay: true,
    // speaker: "by Professor Dr Ioan Stefan Florian / Romania",
    speakerId: "52",
    url: "",
  },
  {
    id: 28,
    date: "2021-06-05",
    start: "08:15 PM",
    end: "08:30 PM",
    desc: "Bypass Surgery For Moyamoya Disease by Prof Dr Satoshi Kuroda / Japan",
    // title: "Session 4: Skull Base/Vascular",
    // speaker: "by Prof Dr Satoshi Kuroda / Japan",
    speakerId: "48",
    // replay: true,
    url: "",
  },
  {
    id: 29,
    date: "2021-06-05",
    start: "08:30 PM",
    end: "08:45 PM",
    desc: "Q&A",
    // title: "Session 4: Skull Base/Vascular",
    // replay: false,
    url: "",
  },
  {
    id: 30,
    date: "2021-06-05",
    start: "08:45 PM",
    end: "08:50 PM",
    desc: "Break",
    // title: "Session 4: Skull Base/Vascular",
    // replay: false,
    url: "",
  },
  {
    id: 31,
    date: "2021-06-05",
    start: "08:50 PM",
    end: "09:50 PM",
    desc: "Latest Development In The Skull Base Surgery by Prof Dr Madjid Samii / Germany",
    title: "Plenary 3: Skull Base",
    // speaker: "by Prof Dr Madjid Samii  / Germany",
    speakerId: "30",
    chairperson1: "Chairperson : Assoc Prof Dato' Dr Hari Chandran",
    chairperson2: "Chairperson : Dr Regunath Kandasamy",
    // replay: true,
    url: "",
  },

  // day2

  {
    id: 32,
    date: "2021-06-06",
    start: "03:00 PM",
    end: "03:20 PM",
    desc: "Sevens AVMs by Prof Dr Michael Lawton",
    title: "Plenary 4: Vascular",
    chairperson1: "Chairperson : Prof Dr Abdul Rahman Izaini Ghani",
    chairperson2: "Chairperson : Dr Kullapat Veerasarn",
    // speaker: "by Prof Dr Michael Lawton ",
    speakerId: "7",
    // replay: true,
    url: "",
  },
  {
    id: 33,
    date: "2021-06-06",
    start: "03:20 PM",
    end: "03:30 PM",
    desc: "Break",
    // title: "Session 5: Vascular",
    // speaker: "by Prof Dr Michael Lawton ",
    // replay: true,
    url: "",
  },
  {
    id: 34,
    date: "2021-06-06",
    start: "03:30 PM",
    end: "03:45 PM",
    desc: "The Simplest STA-MCA Bypass Technique by Prof Dr Bin Xu  / China",
    title: "Session 5: Vascular",
    chairperson1: "Chairperson : Prof Dr Abdul Rahman Izaini  Ghani",
    chairperson2: "Chairperson : Dr Kullapat Veerasarn",
    // speaker: "by Prof Dr Bin Xu  / China",
    speakerId: "13",
    // replay: true,
    url: "",
  },
  {
    id: 35,
    date: "2021-06-06",
    start: "03:45 PM",
    end: "04:00 PM",
    desc: "Awake Craniotomy For Aneurysms And AVMs by Prof Dr Saleem Abdulrauf / United States",
    // title: "Plenary 4: Vascular",
    // chairperson1: "Prof Dr Abdul Rahman Izaini Ghani",
    // chairperson2: "Dr Kullapat Veerasarn",
    // speaker: "by Prof Dr Saleem Abdulrauf / United States ",
    speakerId: "15",
    // replay: true,
    url: "",
  },
  {
    id: 36,
    date: "2021-06-06",
    start: "04:00 PM",
    end: "04:15 PM",
    desc: "Future Of Endovascular Surgery For Vascular Disorders by Prof Dr Pascal Jabbour / United States ",
    // title: "Plenary 4: Vascular",
    // chairperson1: "Prof Dr Abdul Rahman Izaini  Ghani",
    // chairperson2: "Dr Kullapat Veerasarn",
    // speaker: "by Prof Dr Pascal Jabbour / United States",
    speakerId: "37",
    // replay: true,
    url: "",
  },
  {
    id: 37,
    date: "2021-06-06",
    start: "04:15 PM",
    end: "04:30 PM",
    desc: "Q & A",
    // title: "Plenary 4: Vascular",
    // chairperson1: "Prof Dr Abdul Rahman Izaini  Ghani",
    // chairperson2: "Dr Kullapat Veerasarn",
    // speaker: "by Prof Dr Michael Lawton ",
    // replay: true,
    url: "",
  },
  {
    id: 38,
    date: "2021-06-06",
    start: "04:30 PM",
    end: "04:40 PM",
    desc: "Break",
    // title: "Plenary 4: Vascular",
    // chairperson1: "Prof Dr Abdul Rahman Izaini  Ghani",
    // chairperson2: "Dr Kullapat Veerasarn",
    // speaker: "by Prof Dr Michael Lawton ",
    // replay: true,
    url: "",
  },
  {
    id: 39,
    date: "2021-06-06",
    start: "04:40 PM",
    end: "05:00 PM",
    desc: "Pediatric Skull Base Surgery by Prof Dr André Grotenhuis  / Netherlands",
    title: "Plenary 5 : Paediatrics",
    chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr André Grotenhuis  / Netherlands",
    speakerId: "45",
    // replay: true,
    url: "",
  },
  {
    id: 40,
    date: "2021-06-06",
    start: "05:00 PM",
    end: "05:10 PM",
    desc: "Break",
    // title: "Plenary 5 : Paediatrics",
    // chairperson1: "Prof Dr Abdul Rahman Izaini  Ghani",
    // chairperson2: "Dr Kullapat Veerasarn",
    // speaker: "by Prof Dr Michael Lawton ",
    // replay: true,
    url: "",
  },
  {
    id: 41,
    date: "2021-06-06",
    start: "05:10 PM",
    end: "05:25 PM",
    desc: "Intraoperative MRI In Managing Paediatric Cranial Neuro-oncology - Our Experience by Prof Dr Dharmendra Ganesan / Malaysia",
    title: "Session 6: Paediatrics",
    chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr Dharmendra Ganesan / Malaysia",
    speakerId: "96",
    // replay: true,
    url: "",
  },
  {
    id: 42,
    date: "2021-06-06",
    start: "05:25 PM",
    end: "05:40 PM",
    desc: "Occult Spinal Dysraphism by Assoc Prof Dr Seow  Wan Tew / Singapore",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Professor Dr Seow  Wan Tew / Singapore",
    speakerId: "78",
    // replay: true,
    url: "",
  },
  {
    id: 43,
    date: "2021-06-06",
    start: "05:40 PM",
    end: "05:55 PM",
    desc: "Spina Bifida- Ancient Disease, Modern Challenges by Prof Dr Graham Fieggen / South Africa",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr Graham Fieggen / South Africa",
    speakerId: "86",
    // replay: true,
    url: "",
  },
  {
    id: 44,
    date: "2021-06-06",
    start: "05:55 PM",
    end: "06:10 PM",
    desc: "Q&A",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr Graham Fieggen / South Africa",
    // replay: true,
    url: "",
  },
  {
    id: 45,
    date: "2021-06-06",
    start: "06:10 PM",
    end: "06:20 PM",
    desc: "Break",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr Graham Fieggen / South Africa",
    // replay: true,
    url: "",
  },
  {
    id: 46,
    date: "2021-06-06",
    start: "06:20 PM",
    end: "06:40 PM",
    desc: "The Perception Of Complications By Surgeons- Then And Now! by Prof Dr Keki E. Turel / India",
    title: "Plenary 6 : Future of Education and Perspective on World Neurosurgery",
    chairperson1: "Chairperson : Assoc Prof Dato' Dr Hari Chandran",
    chairperson2: "Chairperson : Prof Dr Nasser El-Ghandour ",
    // speaker: "Prof Dr Yoko  Kato / Japan",
    speakerId: "46",
    // replay: true,
    url: "",
  },
  {
    id: 47,
    date: "2021-06-06",
    start: "06:40 PM",
    end: "06:50 PM",
    desc: "Break",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr Graham Fieggen / South Africa",
    // replay: true,
    url: "",
  },
  {
    id: 48,
    date: "2021-06-06",
    start: "06:50 PM",
    end: "07:05 PM",
    desc: "Role & Influence Of Women In Neurosurgery In The Leadership Position by Prof Dr Najia El Abbadi / Morocco",
    title: "Session 7 : Future of Education and Perspective on World Neurosurgery",
    chairperson1: "Chairperson : Assoc Prof Dato' Dr Hari Chandran",
    chairperson2: "Chairperson : Prof Dr Nasser El-Ghandour ",
    // speaker: "Prof Dr Yoko  Kato / Japan",
    speakerId: "22",
    // replay: true,
    url: "",
  },
  {
    id: 49,
    date: "2021-06-06",
    start: "07:05 PM",
    end: "07:20 PM",
    desc: "Impact Of Covid-19 Pandemic On Neurosurgical Education: Present And Future by  Prof Dr Nasser El-Ghandour / Egypt",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr Najia El Abbadi / Morocco",
    speakerId: "9",
    // replay: true,
    url: "",
  },
  {
    id: 50,
    date: "2021-06-06",
    start: "07:20 PM",
    end: "07:35 PM",
    desc: "The Use Of Highlighting Technology In Achieving Remote Hands-on Teaching: A Gilimpse Into Future Neurosurgical Training by Dr Mahmood Qureshi / Kenya",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Dr Mahmood Qureshi / Kenya",
    speakerId: "10",
    // replay: true,
    url: "",
  },
  {
    id: 51,
    date: "2021-06-06",
    start: "07:35 PM",
    end: "07:50 PM",
    desc: "Retrospective Analysis And Development Factors by Prof Dr Abderrahmane Sidi Said / Algeria",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr  Abderrahmane Sidi Said / Algeria",
    speakerId: "11",
    // replay: true,
    url: "",
  },
  {
    id: 52,
    date: "2021-06-06",
    start: "07:50 PM",
    end: "08:05 PM",
    desc:"Future Of Education And Perspective On World Neurosurgery by Prof Dr Yoko Kato / Japan",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr  Abderrahmane Sidi Said / Algeria",
    speakerId: "41",
    // replay: true,
    url: "",
  },
  {
    id: 53,
    date: "2021-06-06",
    start: "08:05 PM",
    end: "08:30 PM",
    desc: "Q&A",
    // title: "Session 6: Paediatrics",
    // chairperson1: "Chairperson : Prof Dr Dharmendra Ganesan",
    // chairperson2: "Chairperson : Dr Vincent Nga",
    // speaker: "by Prof Dr  Abderrahmane Sidi Said / Algeria",
    // replay: true,
    url: "",
  },

  // day3
  {
    id: 54,
    date: "2021-06-07",
    start: "03:00 PM",
    end: "03:20 PM",
    desc: "The CSF Shift & The Virchow Robin Spaces, Cisternostomy & Microsurgery In Brain Trauma by Prof Dr Iype Cherian / India",
    title: "Plenary 7: Trauma",
    chairperson1: "Chairperson : Dr Azman Raffiq",
    chairperson2: "Chairperson : Prof Dato’ Dr Saufi Awang",
    speakerId: "39",
    // replay: true,
    url: "",
  },
  {
    id: 55,
    date: "2021-06-07",
    start: "03:20 PM",
    end: "03:30 PM",
    desc: "Break",
    // title: "Plenary 7: Trauma",
    // chairperson1: "Chairperson : Dr Azman Raffiq",
    // chairperson2: "Chairperson : Prof Dato’ Dr Saufi Awang",
    // replay: true,
    url: "",
  },
  {
    id: 56,
    date: "2021-06-07",
    start: "03:30 PM",
    end: "03:45 PM",
    desc: "Update On Clinical Trials In Neurotrauma by Prof Dr Peter Hutchinson / United Kingdom",
    title: "Session 8: Trauma",
    speakerId: "58",
    chairperson1: "Chairperson : Dr Azman Raffiq",
    chairperson2: "Chairperson : Prof Dato’ Dr Saufi Awang",
    // replay: true,
    url: "",
  },
  {
    id: 57,
    date: "2021-06-07",
    start: "03:45 PM",
    end: "04:00 PM",
    desc: "Neurotrauma Care Through The Pandemic : A Worldwide Approach by Prof Dr Franco Servadei / ltaly",
    speakerId: "33",
    // title: "Session 8: Trauma",
    // replay: true,
    url: "",
  },
  {
    id: 58,
    date: "2021-06-07",
    start: "04:00 PM",
    end: "04:15 PM",
    desc: "Therapeutic Hypothermia & Quantum Thermodynamics In Severe Head Injury by Prof Dr Zamzuri Idris / Malaysia",
    speakerId: "21",
    // title: "Session 8: Trauma",
    // replay: true,
    url: "",
  },
  {
    id: 59,
    date: "2021-06-07",
    start: "04:15 PM",
    end: "04:30 PM",
    desc: "Q&A",
    // title: "Session 8: Trauma",
    // replay: false,
    url: "",
  },
  {
    id: 60,
    date: "2021-06-07",
    start: "04:30 PM",
    end: "04:40 PM",
    desc: "Break",
    // title: "Session 8: Trauma",
    // replay: false,
    url: "",
  },
  {
    id: 61,
    date: "2021-06-07",
    start: "04:40 PM",
    end: "04:55 PM",
    desc: "Robotic Guided Thermocoagulative Hemispherotomy (Rotch) For Drug Resistant Epilepsy- A New Bloodless Technique by Professor Dr P Sarat Chandra / India ",
    title: "Session 9: Epilepsy",
    chairperson1: "Chairperson: Dr M Balamurugan",
    chairperson2: "Chairperson : Dr Sharon Casilda Theophilus",
    speakerId: "53",
    // replay: true,
    url: "",
  },
  {
    id: 62,
    date: "2021-06-07",
    start: "04:55 PM",
    end: "05:10 PM",
    desc: "Surgery For Epilepsy - An Overview by Dr M. Balamurugan / India",
    // speakerId: "87",
    // title: "Session 9: Epilepsy",
    // replay: true,
    url: "",
  },
  {
    id: 63,
    date: "2021-06-07",
    start: "05:10 PM",
    end: "05:25 PM",
    desc: "Q&A",
    // title: "Session 9: Epilepsy",
    // replay: false,
    url: "",
  },
  {
    id: 64,
    date: "2021-06-07",
    start: "05:25 PM",
    end: "05:35 PM",
    desc: "Break",
    // title: "Session 9: Epilepsy",
    // replay: false,
    url: "",
  },
  {
    id: 65,
    date: "2021-06-07",
    start: "05:35 PM",
    end: "05:55 PM",
    desc: "The Future Of Epilepsy Surgery by Professor Dr Frederick Boop / United States",
    title: "Plenary 8: Epilepsy",
    chairperson1: "Chairperson: Dr M Balamurugan",
    chairperson2: "Chairperson : Dr Sharon Casilda Theophilus",
    speakerId: "18",
    // replay: true,
    url: "",
  },
  {
    id: 66,
    date: "2021-06-07",
    start: "05:55 PM",
    end: "06:05 PM",
    desc: "Break",
    // title: "Plenary 8: Epilepsy",
    // replay: false,
    url: "",
  },
  {
    id: 67,
    date: "2021-06-07",
    start: "06:05 PM",
    end: "06:20 PM",
    desc: "Gamma Knife Radiosurgery For Brainstem Metastases by Associate Professor Dr Yeo Tseng Tsai / Singapore",
    title: "Session 10: Radiosurgery",
    chairperson1: "Chairperson : Prof Yeo Tseng Tsai",
    chairperson2: "Chairperson : Assoc Prof Dr Azizi Abu Bakar",
    speakerId: "49",
    // replay: true,
    url: "",
  },
  {
    id: 68,
    date: "2021-06-07",
    start: "06:20 PM",
    end: "06:35 PM",
    desc: "Linac-based Radiosurgery For Parkinson’s And Essential Tremor (As An Alternative To Radiofrequency Ablation And/Or DBS) by Dr Michael Dally / Australia",
    speakerId: "87",
    // title: "Session 10: Radiosurgery",
    // replay: true,
    url: "",
  },
  {
    id: 69,
    date: "2021-06-07",
    start: "06:35 PM",
    end: "07:05 PM",
    desc: "Q&A",
    // title: "Session 10: Radiosurgery",
    // replay: false,
    url: "",
  },
  {
    id: 70,
    date: "2021-06-07",
    start: "07:05 PM",
    end: "07:15 PM",
    desc: "Break",
    // title: "Session 10: Radiosurgery",
    // replay: false,
    url: "",
  },
  // {
  //   id: 70,
  //   date: "2021-06-07",
  //   start: "07:15 PM",
  //   end: "07:30 PM",
  //   desc: "Coming soon by Dr Joel Caballero / Cuba",
  //   title: "Session 11: Minimally Invasive / Endoscopic Neurosurgery",
  //   chairperson1:"Chairperson : Prof Yeo Tseng Tsai ",
  //   chairperson2:"Chairperson : Assoc Prof Dr Azizi Abu Bakar",
  //   speakerId: "49",
  //   // replay: true,
  //   url: "",
  // },
  {
    id: 71,
    date: "2021-06-07",
    start: "07:15 PM",
    end: "07:30 PM",
    desc: "Endoscopy For Intrinsic Brain Tumours by Assoc Prof Dr Puneet Plaha / UK",
    title: "Session 11: Minimally Invasive / Endoscopic Neurosurgery",
    chairperson1: "Chairperson : Prof Yeo Tseng Tsai ",
    chairperson2: "Chairperson : Assoc Prof Dr Azizi Abu Bakar",
    // replay: true,
    speakerId: "100",
    url: "",
  },
  {
    id: 72,
    date: "2021-06-07",
    start: "07:30 PM",
    end: "07:45 PM",
    desc: "The Surgical Treatment Of Anterior Skull Base Tumour By Supraorbital Keyhole Approach by Assoc Prof Dr Dong Van He  / Vietnam",
    // title: "Session 11: Minimally Invasive / Endoscopic Neurosurgery",
    // replay: true,
    speakerId: "29",
    url: "",
  },
  {
    id: 73,
    date: "2021-06-07",
    start: "07:45 PM",
    end: "08:00 PM",
    desc: "State-Of-The-Art Microsurgical Treatment Of Anterior Circulation Aneurysms by Assoc Prof Dr Asra Al Fauzi / Indonesia",
    // title: "Session 11: Minimally Invasive / Endoscopic Neurosurgery",
    // replay: true,
    speakerId: "60",
    url: "",
  },
  {
    id: 74,
    date: "2021-06-07",
    start: "08:00 PM",
    end: "08:30 PM",
    desc: "Q&A",
    // title: "Session 11: Minimally Invasive / Endoscopic Neurosurgery",
    // replay: false,
    url: "",
  },
  {
    id: 75,
    date: "2021-06-07",
    start: "08:30 PM",
    end: "08:40 PM",
    desc: "Break",
    // title: "Session 11: Minimally Invasive / Endoscopic Neurosurgery",
    // replay: false,
    url: "",
  },
  {
    id: 76,
    date: "2021-06-07",
    start: "08:40 PM",
    end: "09:00 PM",
    desc: "The Finesse of Jugular Foramen Surgery by Professor Dr Ossama Al-Mefty / USA",
    title: "Plenary 9: Skull Base",
    speakerId: "23",
    chairperson1:"Chairperson : Assoc Prof Dato' Dr Hari Chandran ",
    chairperson2:"Chairperson : Dr Regunath Kandasamy",
    // replay: true,
    url: "",
  },
  {
    id: 77,
    date: "2021-06-07",
    start: "09:00 PM",
    end: "09:15 PM",
    desc: "Thank You Remarks & Closing Ceremony",
    // title: "Plenary 9: Skull Base",
    // replay: false,
    url: "",
  },
]